import React from 'react';
import dayjs from 'dayjs';
import { FaExclamationTriangle } from 'react-icons/fa';

export const toAbsoluteUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http://') || url.startsWith('https://')) return url;
    return `https://${url}`;
};

export const CertificateExpiryBadge = ({ courseExpiresAt, fontSize = '1rem' }) => {
    if (!courseExpiresAt) return null;

    const expiry = dayjs(courseExpiresAt);
    const now = dayjs();
    const daysUntilExpiry = expiry.diff(now, 'day');

    let badgeClass = 'badge-success';
    let badgeText = 'Valid';
    let icon = null;

    if (daysUntilExpiry < 0) {
        badgeClass = 'badge-danger';
        badgeText = 'Expired';
        icon = <FaExclamationTriangle className="mr-1" />;
    } else if (daysUntilExpiry <= 30) {
        badgeClass = 'badge-danger';
        badgeText = `Expires in ${daysUntilExpiry}d`;
        icon = <FaExclamationTriangle className="mr-1" />;
    } else if (daysUntilExpiry <= 60) {
        badgeClass = 'badge-warning';
        badgeText = `Expires in ${daysUntilExpiry}d`;
    } else if (daysUntilExpiry <= 90) {
        badgeClass = 'badge-info';
        badgeText = `Expires in ${daysUntilExpiry}d`;
    } else {
        badgeText = `Valid until ${expiry.format('MMM D, YYYY')}`;
    }

    return (
        <span className={`badge ${badgeClass}`} style={{ fontSize, padding: '4px 8px' }}>
            {icon}
            {badgeText}
        </span>
    );
};

export default CertificateExpiryBadge;
